import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';
import useMobile from 'utils/useMobile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    width: '100%',
    color: '#fff',
    paddingTop: spacing(6),
    paddingBottom: spacing(12),
    backgroundColor: palette.grey['900']
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: spacing(6),
    paddingRight: spacing(6),
    paddingBottom: spacing(4),
    textAlign: 'center'
  },
  socialLinks: {
    display: 'flex'
  },
  icon: {
    paddingLeft: 16
  }
}));

const SectionFooter = () => {
  const classes = useStyles({})
;
  const isMobile = useMobile();
  const align = isMobile ? 'center' : 'left';
  return (
    <footer id="footer" className={classes.root}>
      <Grid container direction="row" justify="space-between">
        <Grid className={classes.panel} xs={12} md={4} item>
          <Typography variant="h5" gutterBottom align={align}>
            CONTACT
          </Typography>
          <Link href="mailto:kenlaney@kenlaneyfit.com" align={align}>
            kenlaney@kenlaneyfit.com
          </Link>
        </Grid>
        <Grid className={classes.panel} xs={12} md={4} item>
          <Typography variant="h5" gutterBottom align={align}>
            LEGAL
          </Typography>
          <TermsOfUse alignLink={align} />
          <PrivacyPolicy alignLink={align} />
          <Typography variant="body2" align={align}>
            Copyright 2019 BODYF1RST
          </Typography>
        </Grid>
        <Grid className={classes.panel} xs={12} md={4} item>
          <Typography variant="h5" gutterBottom align={align}>
            SOCIAL MEDIA
          </Typography>
          <Grid container justify={isMobile ? 'center' : 'flex-start'}>
            <Grid item>
              <a
                className={classes.icon}
                href="https://www.facebook.com/bodyf1rst/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon color="#3B5998" icon={['fab', 'facebook-square']} size="2x" />
              </a>
            </Grid>
            <Grid item>
              <a
                className={classes.icon}
                href="https://www.instagram.com/bodyf1rst/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon color="#3F729B" icon={['fab', 'instagram']} size="2x" />
              </a>
            </Grid>
            <Grid item>
              <a
                className={classes.icon}
                href="https://www.youtube.com/channel/UCdMJhWTHm-HA-evYK0r4NWA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon color="#FF3333" icon={['fab', 'youtube']} size="2x" />
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </footer>
  );
};

export default SectionFooter;
